var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('welcome-box',[_c('promo-notice'),_vm._v(" "),_c('login-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }